import { Component, Input } from '@angular/core';

import { HeaderComponent } from './header.component';
import { FooterComponent } from './footer.component';

@Component({
  selector: 'app-legal-layout',
  standalone: true,
  imports: [HeaderComponent, FooterComponent],
  templateUrl: './legal-layout.component.html',
  styleUrl: './legal-layout.component.css'
})
export class LegalLayoutComponent {
  @Input() title: string = '';
  @Input() lastUpdated: string = '';
}

